import React from 'react';
import './PlaceholderPage.css';

const InviteUsersPage = () => {
  return (
    <div className="placeholder-page">
      <h1 className="page-title">Invite Users</h1>
      <p className="page-description">
        User invitation form with role assignment will be added here.
      </p>
      
      <div className="invite-placeholder">
        <div className="form-field">
          <label>Email Address</label>
          <input type="email" placeholder="user@example.com" />
        </div>
        <div className="form-field">
          <label>Role</label>
          <select>
            <option>Select Role</option>
            <option>Admin</option>
            <option>Manager</option>
            <option>User</option>
          </select>
        </div>
        <button className="action-btn" onClick={(e) => { e.preventDefault(); alert('Invitation functionality will be added soon!'); }}>Send Invitation</button>
      </div>
    </div>
  );
};

export default InviteUsersPage;
